import React, { useEffect, useState } from 'react';
import { App, Flex, Form } from 'antd';

import { FeedForm } from '../components/FeedForm';
import { createFormData } from '../../../../../utils/common/createFormData';
import { initial } from '../utils/options';
import { Save } from '../../../widgets/Save';
import { FeedTypes } from '../service/feed.interface';
import {
    useCreateFeedMutation,
    useCreateFileFeedMutation,
} from '../service/feed.api';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useFeed } from '../hooks/useFeed';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';

export const FeedSettingsContainer = () => {
    const current = useAppSelector(selectShopCurrent);
    const { notification } = App.useApp();

    const [form] = Form.useForm();
    const values = Form.useWatch([], form);

    const { data } = useFeed();

    const queryHook = (type: FeedTypes) => {
        switch (type) {
            case FeedTypes.fileYml:
                return useCreateFileFeedMutation();
            default:
                return useCreateFeedMutation();
        }
    };

    const [createFeed, { isSuccess, isError, error, isLoading }] = queryHook(
        values?.type
    );

    const [isSubmittable, setIsSubmittable] = useState<boolean>(false);

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, {
        message: 'Фид успешно подключен',
        description: 'Загрузка может занять до суток.',
    });

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                ...data,
                feed_frequency: data.frequency,
                feed_url: data.url,
            });
        }
    }, [data]);

    useEffect(() => {
        form.validateFields({ validateOnly: true })
            .then(() => setIsSubmittable(true))
            .catch(() => setIsSubmittable(false));
    }, [form, values]);

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Фид успешно подключен',
                description: 'Загрузка может занять до суток.',
            });
        }
    }, [isSuccess]);

    const handleSave = async () => {
        let payload;
        if (values?.type === FeedTypes.fileYml) {
            payload = {
                id: current.id,
                body: createFormData({
                    type: 1,
                    feed_file: values.feed_file[0].originFileObj,
                }),
            };
        } else {
            payload = {
                id: current.id,
                ...values,
            };
        }

        await createFeed(payload);
    };

    return (
        <Flex vertical gap={24}>
            <FeedForm form={form} initial={initial} />
            <Save
                onSave={handleSave}
                disabled={!isSubmittable}
                loading={isLoading}
            />
        </Flex>
    );
};
